import { useContext, useState, useEffect, React, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Row, Input } from "reactstrap";
import "./CancelSpecialBilling.css";
import * as Constants from "../../../utils/Constants";
import * as DateUtil from "../../../utils/DateUtil";
import "react-tabs/style/react-tabs.css";
import { formDataContext } from "../SpecialBillingPage";
import { Search, ArrowRightAlt } from "@mui/icons-material";
import BillingDetail from "../../BillingDetail/BillingDetail";
import {
  CustomPagination,
  MessageAlert,
  ModalComponent,
  TextField,
  DatePicker,
  Dropdown,
  Button,
} from "../../../components/Components";

function CancelSpecialBilling() {
  const {
    UserInfoData,
    tradeDiscountPercent,
    selectedSubNo,
    getSpecialBilling,
    cancelSpecialBill,
    billTypeList,
  } = useContext(formDataContext);

  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [selectedSpecialStatus, setSelectedSpecialStatus] = useState(null);
  const [optionSpecialStatus, setOptionSpecialStatus] = useState([]);
  const [startAdvDate, setStartAdvDate] = useState(
    getDateEven(new Date(new Date().toDateString()), 30, false)
  );
  const [endAdvDate, setEndAdvDate] = useState(
    getDateEven(new Date(new Date().toDateString()), 0, false)
  );
  const [summaryBillNo, setSummaryBillNo] = useState(null);
  const [searchResult, setSearchResult] = useState(null);
  const [isOpenModalBillingDetail, setIsOpenModalBillingDetail] =
    useState(false);
  const [billingDetail, setBillingDetail] = useState(null);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const handlePageSpecialBillChange = async (newPage) => {
    try {
      if (
        searchResult[(newPage - 1) * pageSize]?.value === null ||
        searchResult[(newPage - 1) * pageSize]?.value === undefined
      ) {
        if (!startAdvDate || !endAdvDate)
          throw new Error(
            t("PleaseSpecifyFormat", { format: t("DeliveryDate") })
          );
        let result = await getSpecialBilling({
          advDateStart:
            DateUtil.ConvertInputDateToISOFormatDateTimeString(startAdvDate),
          advDateEnd:
            DateUtil.ConvertInputDateToISOFormatDateTimeString(endAdvDate),
          subno: selectedSubNo,
          advNo: summaryBillNo,
          billingStatus: selectedSpecialStatus?.value,
          startRow: (newPage - 1) * pageSize,
          pageSize: pageSize,
        });
        const tempResult = searchResult.map((billing, index) =>
          index >= (newPage - 1) * pageSize &&
          index <= (newPage - 1) * pageSize + pageSize - 1
            ? {
                ...billing,
                value: result?.billingList[index - (newPage - 1) * pageSize],
              }
            : billing
        );
        setSearchResult(tempResult);
        setIsSelectAll(
          tempResult
            ?.slice(
              (newPage - 1) * pageSize,
              (newPage - 1) * pageSize + pageSize
            )
            ?.every((billing) => billing?.isCheck)
        );
      } else {
        const billingCheck = searchResult?.slice(
          (newPage - 1) * pageSize,
          (newPage - 1) * pageSize + pageSize
        );
        setIsSelectAll(
          billingCheck && billingCheck.length > 0
            ? billingCheck.every((billing) => billing?.isCheck)
            : false
        );
      }
      setPage(newPage);
    } catch (error) {
      MessageAlert.error({
        title: t("Error"),
        message: error?.message,
      });
    }
  };

  const searchSpecialBilling = async (pageSizeSearch) => {
    try {
      if (!startAdvDate || !endAdvDate)
        throw new Error(
          t("PleaseSpecifyFormat", { format: t("DeliveryDate") })
        );
      let result = await getSpecialBilling({
        advDateStart:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(startAdvDate),
        advDateEnd:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(endAdvDate),
        subno: selectedSubNo,
        advNo: summaryBillNo,
        billingStatus: selectedSpecialStatus?.value,
        startRow: 0,
        pageSize: pageSizeSearch,
      });
      if (result?.billingList && result?.billingList?.length > 0) {
        let tempResult = Array.from(
          { length: result?.totalRecord },
          () => null
        );
        tempResult.splice(
          0,
          result?.billingList?.length,
          ...result?.billingList?.map(function (item) {
            return {
              value: item,
              isCheck: false,
            };
          })
        );
        setSearchResult(tempResult);
        setPageSize(pageSizeSearch);
        setPageCount(Math.ceil((result?.totalRecord ?? 0) / pageSizeSearch));
        setPage(1);
        setIsSelectAll(false);
      } else {
        setSearchResult([]);
      }
    } catch (error) {
      MessageAlert.error({
        title: t("Error"),
        message: error?.message,
      });
    }
  };

  const onClickCancelSpecialofBilling = async () => {
    let checkedBill = searchResult?.filter((billing) => billing?.isCheck);

    MessageAlert.confirm({
      title: t("WanttoCancelSpecialBilling"),
      html: `
      <table>
          <tbody>
              <tr>
                  <td>
                      <label>${t("SpecialBillingCancellationItems", {
                        countADV: checkedBill?.length,
                      })}</label>
                  </td>
              </tr>
          </tbody>
      </table>
      <div style="max-height: 100px; overflow-y: auto; background: lightgray;">
        <label>${checkedBill
          ?.map((item) => item?.value.advNo)
          ?.join(", ")}</label>
      </div> `,
      hidenIcon: true,
      onConfirm: async () => {
        if (
          await cancelSpecialBill({
            cancelBy: UserInfoData?.chiefNo,
            status: Constants.Status.No,
            cancelList: checkedBill?.map(function (item) {
              return item?.value?.advNo;
            }),
          })
        ) {
          await MessageAlert.success({
            title: t("Warning"),
            message: t("BillingSavedSuccessfully"),
            confirmButtonText: t("Confirm"),
          });
          searchSpecialBilling(pageSize);
        }
      },
    });
  };

  const handleInputSummaryBillNoChange = (e) => {
    const value = e.target.value;
    setSummaryBillNo(value);
  };

  const onGetBilling = async (advNo) => {
    setBillingDetail({
      advno: advNo,
    });
    setIsOpenModalBillingDetail(true);
  };

  const getBillingStatusDesc = (status) => {
    let statusDesc =
      billTypeList?.find((item) => item.configValue === status)?.configDesc ??
      "-";

    return statusDesc;
  };

  function getDateEven(date, numDate, isPluss) {
    let futureDate = new Date(date);
    futureDate.setDate(
      futureDate.getDate() + (isPluss ? numDate : numDate * -1)
    );
    return futureDate;
  }

  const handleCheckSelectAll = (e) => {
    const startIndex = (page - 1) * pageSize;
    setIsSelectAll(e.target.checked);
    const updatedBilling = searchResult.map((billing, index) =>
      index >= startIndex && index <= startIndex + pageSize - 1
        ? { ...billing, isCheck: e.target.checked }
        : billing
    );
    setSearchResult(updatedBilling);
  };

  const handleCheckSelectBilling = (e, index) => {
    const currentIndex = (page - 1) * pageSize + index;
    const updatedBilling = searchResult.map((billing, idx) =>
      idx === currentIndex ? { ...billing, isCheck: e.target.checked } : billing
    );
    setSearchResult(updatedBilling);
    setIsSelectAll(
      updatedBilling
        ?.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize)
        ?.every((billing) => billing?.isCheck)
    );
  };

  useEffect(() => {
    setSearchResult(null);
    setIsSelectAll(false);
    setStartAdvDate(
      getDateEven(new Date(new Date().toDateString()), 30, false)
    );
    setEndAdvDate(getDateEven(new Date(new Date().toDateString()), 0, false));
    setSummaryBillNo("");
  }, [selectedSubNo]);

  useEffect(() => {
    let optionBillType = billTypeList?.map((item) => {
      return { label: item.configDesc, value: item.configValue };
    });
    setOptionSpecialStatus(optionBillType);
    if (
      optionBillType &&
      optionBillType.length > 0 &&
      optionBillType.find((type) => type.value === Constants.BillingStatus.All)
    ) {
      setSelectedSpecialStatus(
        optionBillType.filter(
          (type) => type.value === Constants.BillingStatus.All
        )[0]
      );
    }
  }, [billTypeList]);

  return (
    <>
      <div
        style={{
          padding: "0 .5% 1% .5%",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <Card style={{ padding: "15px", borderWidth: "0px" }}>
          <Row>
            <Col className="TextHead RowDeatail">
              <label>{t("CancelSpecialofBilling")}</label>
            </Col>
          </Row>
          <Row style={{ paddingBottom: "5px" }}>
            <Col xs={2} sm={2} md={2} lg={2} className="TextRight">
              <label>{t("SpecialStatus")}</label>
            </Col>
            <Col xs={4} sm={4} md={4} lg={3} className="TextLeft">
              <Dropdown
                id="StatusDropdown"
                value={selectedSpecialStatus}
                onChange={(e) => {
                  setSelectedSpecialStatus(e);
                }}
                width={"100%"}
                options={optionSpecialStatus}
                placeholder={t("All")}
                isDisabled={false}
                isClearable={true}
              />
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} className="TextRight">
              <label>{t("SpecialBillingRequestNo")}</label>
            </Col>
            <Col xs={4} sm={4} md={4} lg={3} className="TextRight">
              <TextField
                name="articleService"
                style={{ width: "90%" }}
                placeholder={t("BillingNumber")}
                value={summaryBillNo}
                onChange={handleInputSummaryBillNoChange}
                disabled={false}
              />
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={2} sm={2} md={2} lg={2} className="TextRight">
              <label>{t("DeliveryDate")}</label>
            </Col>
            <Col xs={4} sm={4} md={2} lg={3} className="TextRight">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={startAdvDate}
                minDate={getDateEven(new Date(), 30, false)}
                maxDate={getDateEven(new Date(), 0, false)}
                onChange={(date) => {
                  setStartAdvDate(date);
                  setEndAdvDate(getDateEven(date, 30, true));
                }}
              />
            </Col>
            <Col xs={2} sm={2} md={1} lg={1} className="TextCenter">
              <label>-</label>
            </Col>
            <Col xs={4} sm={4} md={2} lg={3} className="TextRight">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={endAdvDate}
                minDate={startAdvDate}
                maxDate={getDateEven(startAdvDate, 30, true)}
                onChange={(date) => {
                  setEndAdvDate(date);
                }}
              />
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={2} sm={2} md={2} lg={2} className="TextRight"></Col>
            <Col
              xs={10}
              sm={10}
              md={10}
              lg={10}
              className="TextLeft TextWarning"
            >
              <label>({t("RemarkSelectDeliveryDate")})</label>
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={2} sm={2} md={2} lg={1} className="TextRight"></Col>
            <Col
              xs={10}
              sm={10}
              md={10}
              lg={5}
              className="TextLeft TextWarning"
            ></Col>
            <Col xs={12} sm={12} md={12} lg={6} className="ConTentRight">
              <div style={{ paddingRight: "15px" }}>
                <Button
                  className={
                    !searchResult ||
                    searchResult.length === 0 ||
                    searchResult?.every(
                      (billing) =>
                        !billing?.isCheck ||
                        searchResult.some(
                          (billing) =>
                            (billing?.isCheck ?? false) &&
                            Constants.BillingStatus.Special !==
                              billing.value.billingTypeStatus
                        )
                    )
                      ? "disabledCancelButton"
                      : "buttonCancelSpecialRounds"
                  }
                  style={{ width: "180px" }}
                  disabled={
                    !searchResult ||
                    searchResult.length === 0 ||
                    searchResult?.every((billing) => !billing?.isCheck) ||
                    searchResult.some(
                      (billing) =>
                        (billing?.isCheck ?? false) &&
                        Constants.BillingStatus.Cancel ===
                          billing.value.billingTypeStatus
                    )
                  }
                  title={t("CancelSpecialofBilling")}
                  onClick={onClickCancelSpecialofBilling}
                />
              </div>
              <div>
                <Button
                  style={{ width: "120px", position: "relative" }}
                  title={t("Search")}
                  icon={
                    <Search
                      style={{
                        position: "absolute",
                        top: "6px",
                        right: "10px",
                        height: "25px",
                        width: "25px",
                      }}
                    />
                  }
                  onClick={() => searchSpecialBilling(pageSize)}
                />
              </div>
            </Col>
          </Row>
        </Card>

        <Card style={{ padding: "15px", borderWidth: "0px" }}>
          <Row>
            <Col className="TextHead RowDeatail">
              <label>{t("SearchResult")}</label>
            </Col>
          </Row>
          <Row>
            <div style={{ marginLeft: "1px", marginRight: "5px" }}>
              <table
                className="TableBill"
                style={{ width: "100%", marginTop: "10px" }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#1976d2",
                      height: "50px",
                      color: "white",
                    }}
                  >
                    <th>
                      <Input
                        type="checkbox"
                        checked={isSelectAll}
                        onChange={(e) => {
                          handleCheckSelectAll(e);
                        }}
                        disabled={!searchResult || !searchResult?.length === 0}
                        className={isSelectAll ? "blue-checkbox-input" : ""}
                        style={{
                          width: "20px",
                          height: "20px",
                          backgroundColor: isSelectAll ? "white" : "",
                        }}
                      />
                    </th>
                    <th>{t("DeliveryDate")}</th>
                    <th>{t("BillingCycle")}</th>
                    <th>{t("SummaryBillNo")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Income")}</th>
                    <th>
                      {t("Income")} ({tradeDiscountPercent}%)
                    </th>
                    <th>{t("EstimatedIncome")}</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResult
                    ?.slice(
                      (page - 1) * pageSize,
                      Math.min(page * pageSize, searchResult?.length)
                    )
                    ?.map((item, index) => {
                      let isReject =
                        Constants.BillingStatus.Reject ===
                          item?.value?.billingTypeStatus ||
                        Constants.BillingStatus.Cancel ===
                          item?.value?.billingTypeStatus;
                      return (
                        <Fragment>
                          <tr
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#E4EEFF" : "white",
                              height: "40px",
                            }}
                          >
                            <td className="boaderTop">
                              <Input
                                type="checkbox"
                                checked={item?.isCheck ?? false}
                                onChange={(e) => {
                                  handleCheckSelectBilling(e, index);
                                }}
                                className={
                                  item?.isCheck ?? false
                                    ? "blue-checkbox-input"
                                    : ""
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  backgroundColor:
                                    item?.isCheck ?? false ? "white" : "",
                                }}
                              />
                            </td>
                            <td className="boaderTop">
                              <label>
                                {DateUtil.ConvertDatetoFormatdateNormal(
                                  item?.value?.advDate
                                )}
                              </label>
                            </td>
                            <td className="boaderTop">
                              <label>{t("Special")}</label>
                            </td>
                            <td
                              className="boaderTop"
                              style={{ color: "#2767BA" }}
                            >
                              <label
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => onGetBilling(item?.value?.advNo)}
                              >
                                {item?.value?.advNo}
                              </label>
                            </td>
                            <td className="boaderTop">
                              <label
                                style={{
                                  color: isReject ? "red" : "black",
                                }}
                              >
                                {getBillingStatusDesc(
                                  item?.value?.billingTypeStatus
                                )}
                              </label>
                            </td>
                            <td className="boaderTop">
                              <label
                                style={{
                                  color: isReject ? "red" : "black",
                                }}
                              >
                                {Number(item?.value?.totalIncome)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </label>
                            </td>
                            <td className="boaderTop">
                              <label
                                style={{
                                  color: "red",
                                }}
                              >
                                {Number(item?.value?.tradeDiscount)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </label>
                            </td>
                            <td className="boaderTop">
                              <label
                                style={{
                                  color: isReject ? "red" : "#378D2C",
                                }}
                              >
                                {Number(item?.value?.estimateTotal)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </label>
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })}
                </tbody>
              </table>
              <div style={{ position: "relative", left: "12px" }}>
                <CustomPagination
                  page={page}
                  pageSize={pageSize}
                  pageCount={pageCount}
                  onPageChange={handlePageSpecialBillChange}
                  rowsPerPageOptions={[5, 10, 25]}
                  onPageSizeChange={(newPage) => searchSpecialBilling(newPage)}
                />
              </div>
            </div>
          </Row>
        </Card>
      </div>
      <ModalComponent
        className="custom-modal"
        id="openBillingDetailModal"
        isOpen={isOpenModalBillingDetail}
        onClose={() => setIsOpenModalBillingDetail(false)}
        size={"xl"}
        title={<span className="textHeader">{t("BillingDetail")}</span>}
      >
        {
          <BillingDetail
            billing={billingDetail}
            isModal={true}
            isHideTitle={true}
            setIsOpenModalBillingDetail={setIsOpenModalBillingDetail}
          />
        }
      </ModalComponent>
    </>
  );
}

export default CancelSpecialBilling;
